import React, { useEffect, useState } from 'react'
import activeFolderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import { useIntl } from 'react-intl'
import EditSpaceFileRow from '../components/EditSpaceFileRow'
import { useParams } from 'react-router-dom'
import { getDataRoomContent } from '../core/_requests'
import { toast } from 'react-toastify'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import OutsideClickHandler from 'react-outside-click-handler'
import SpaceFileDropdown from '../components/SpaceFileDropdown'
import moreOptionIcon from '../../../../_metronic/assets/images/svg/data-room/more-options-icon.svg'
import ViewFileModal from './ViewFileModal'
import NoDataPage from '../../widgets/components/NoDataPage'
import { ContentTypes } from '../core/_constants'
import { toAbsoluteUrl } from '../../../../_metronic/helpers/index'
import { useAuth } from '../../auth'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function SpaceAllFiles({ isHidden, isTrash }: { isHidden?: string; isTrash?: string }) {
  const defaultIsHidden = 'all'
  const defaultIsTrash = 'all'

  const is_hidden = isHidden !== undefined ? isHidden : defaultIsHidden
  const is_Trash = isTrash !== undefined ? isTrash : defaultIsTrash

  const { dataRoomId } = useParams()
  const [initialLoading, setInitialLoading] = useState<boolean>(false)
  const [dataRoomContentLoading, setDataRoomContentLoading] = useState<boolean>(false)
  const [dataRoomContentByParentLoading, setDataRoomContentByParentLoading] = useState(false)
  const [dataRoomContent, setSingleDataRoomContent] = useState<any>()
  const [dataRoomContentParent, setDataRoomContentParent] = useState<any>()
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const [menuOpen, setMenuOpen] = useState<number | null>(null)
  const [showViewFileModal, setShowViewFileModal] = useState<boolean>(false)
  const [fileOriginalNameToView, setFileOriginalNameToView] = useState<string>('')
  const [fileContentName, setFileContentName] = useState<string>('')
  const [breadcrumbDataRoom, setBreadcrumbDataRoom] = useState<any>([])
  const [dRTitle, setDRTitle] = useState<string>('')
  const [breadcrumbLength, setBreadcrumbLength] = useState<number>(0)
  const { setIsFoldersPresent } = useAuth()
  const {
    refreshFuncBool,
    setRefreshFuncBool,
    oneDropdownOpenBool,
    setOneDropdownOpenBool,
    setDataRoomLatestBreadcrumbId,
    dataRoomLatestBreadcrumbId,
    setDataRoomLatestBreadcrumbContentId,
  } = useMoveToFolderData()
  const [renameModalContentId] = useState<number | null>(null)
  const getDataRoomContentById = async () => {
    try {
      if (initialLoading) {
        setDataRoomContentLoading(true)
      }
      if (dataRoomId) {
        const {
          data: { data, success, errors },
        } = await getDataRoomContent(
          parseInt(dataRoomId),
          is_hidden !== defaultIsHidden
            ? is_hidden
            : is_Trash !== defaultIsTrash
              ? is_Trash
              : 'all',
          null
        )
        if (success) {
          setInitialLoading(true)
          setSingleDataRoomContent(data.dataRooms)
          setDRTitle(data?.dataRooms?.title)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDataRoomContentLoading(false)
    }
  }
  useEffect(() => {
    getDataRoomContentById()
  }, [dataRoomId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (
    index: number,
    parentId: number,
    type: string,
    fileName: string,
    name: string,
    contentId: any
  ) => {
    if (type === 'FOLDER') {
      setActiveIndex(contentId === activeIndex ? activeIndex : contentId)
      getDataRoomContentByparentId(parentId)
      setDataRoomLatestBreadcrumbId(parentId)
      setDataRoomLatestBreadcrumbContentId(contentId)
    } else {
      setShowViewFileModal(true)
      setFileOriginalNameToView(fileName)
      setFileContentName(name)
    }
  }

  // const getDataRoomContentByparentId = async (parentId: number) => {
  //   try {
  //     setDataRoomContentByParentLoading(true)
  //     if (parentId) {
  //       const {
  //         data: {data, success, errors},
  //       } = await getDataRoomContentParent(parentId)
  //       if (success) {
  //         setDataRoomContentParent(data)
  //         setBreadcrumbDataDR(data?.breadcrumb)
  //       } else {
  //         errors.forEach((error: string) => {
  //           toast.error(formatMessage({id: error}))
  //         })
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   } finally {
  //     setDataRoomContentByParentLoading(false)
  //   }
  // }

  const getDataRoomContentByparentId = async (parentId: any) => {
    try {
      setDataRoomContentByParentLoading(true)
      if (dataRoomId) {
        const {
          data: { data, success, errors },
        } = await getDataRoomContent(
          parseInt(dataRoomId),
          is_hidden !== defaultIsHidden ? is_hidden : is_Trash !== defaultIsTrash ? is_Trash : '',
          parentId
        )
        if (success) {
          setDataRoomContentParent(data.dataRooms.contents)
          setBreadcrumbDataRoom(data.breadcrumb.reverse())
          setIsFoldersPresent(data.breadcrumb.reverse())
          setBreadcrumbLength(data.breadcrumb?.length)
          setRefreshFuncBool(false)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDataRoomContentByParentLoading(false)
      setRefreshFuncBool(false)
    }
  }

  const { formatMessage } = useIntl()

  const handleBreadCrumbIdClick = (id: any, contentId: any) => {
    setActiveIndex(contentId === activeIndex ? activeIndex : contentId)
    setDataRoomLatestBreadcrumbId(id)
    getDataRoomContentByparentId(id)
    setDataRoomLatestBreadcrumbContentId(contentId)
  }

  useEffect(() => {
    if (refreshFuncBool) {
      getDataRoomContentById()
      getDataRoomContentByparentId(dataRoomLatestBreadcrumbId)
    }
  }, [refreshFuncBool]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* {dataRoomContentLoading ? <Spinner /> : null} */}
      {!dataRoomContentLoading && dataRoomContent?.contents?.length > 0 ? (
        <>
          <div className='ms-4 my-4'>
            {breadcrumbDataRoom && (
              <ul className='breadcrumb  text-muted  font-size-16 font-weight-600 '>
                <li
                  className='breadcrumb-item pe-3 text-primary cursor-pointer'
                  onClick={() => {
                    handleBreadCrumbIdClick(null, null)
                  }}
                >
                  <span className='pe-3'>{dRTitle}</span>
                </li>
                {breadcrumbDataRoom.length > 0 && (
                  <li
                    className='breadcrumb-item pe-3 text-primary cursor-pointer'
                    onClick={() => {
                      handleBreadCrumbIdClick(
                        breadcrumbDataRoom[0].id,
                        breadcrumbDataRoom[0].contentId
                      )
                    }}
                  >
                    <img src={folderIcon} alt=''></img>
                    <span className='pe-3 ms-1'>{breadcrumbDataRoom[0].name}</span>
                  </li>
                )}
                {breadcrumbDataRoom.length >= 1 &&
                  breadcrumbDataRoom.slice(1).map((item: any, id: number) => (
                    <li
                      className={`breadcrumb-item pe-3 ${id === 1 ? 'text-dark' : 'text-primary cursor-pointer'
                        }`}
                      key={id}
                      onClick={() => {
                        handleBreadCrumbIdClick(item.id, item.contentId)
                      }}
                    >
                      <img src={folderIcon} alt=''></img>
                      <span className='pe-3 ms-1'>{item.name}</span>
                    </li>
                  ))}
              </ul>
            )}
          </div>
          <div className='space-all-files-wrapper d-md-flex flex-row'>
            <div className='space-all-files-left dark-border'>
              <div>
                {dataRoomContent?.contents &&
                  dataRoomContent.contents.map((content: any, index: number) => (
                    <div className=' file-nav-list dark-border' key={index}>
                      <div
                        className={`d-flex align-items-center file-nav justify-content-between ${content?.type === ContentTypes.FOLDER &&
                          content?.contentId === activeIndex
                          ? 'active'
                          : ''
                          }`}
                      >
                        <div
                          onClick={() => {
                            handleClick(
                              index,
                              content?.dataroom_content?.dataroom_contentId,
                              content?.type,
                              content?.file?.name,
                              content?.name,
                              content?.contentId
                            )
                          }}
                          className={`d-flex align-items-center file-nav justify-content-between`}
                        >
                          {content?.type === ContentTypes.FOLDER ? (
                            <>
                              <img
                                src={activeFolderIcon}
                                alt={formatMessage({ id: 'folder-icon' })}
                              />
                              <p className='mb-0 ms-2'>{content?.name}</p>
                            </>
                          ) : (
                            <>
                              {content && content?.file?.name.split('.').pop() === 'pdf' && (
                                <img
                                  height={35}
                                  width={35}
                                  alt={formatMessage({ id: 'pdf' })}
                                  className='pe-2'
                                  src={toAbsoluteUrl(`/media/icons/file_extensions/${content?.file?.name.split('.').pop()}.svg`)}
                                />
                              )}
                              {content &&
                                (content?.file?.name.split('.').pop() === 'docx' ||
                                  content?.file?.name.split('.').pop() === 'doc') && (
                                  <img
                                    height={35}
                                    width={37}
                                    alt={formatMessage({ id: 'docx' })}
                                    className='pe-2'
                                    src={toAbsoluteUrl(`/media/icons/file_extensions/${content?.file?.name.split('.').pop()}.svg`)}
                                  />
                                )}
                              {content &&
                                (content?.file?.name.split('.').pop() === 'pptx' ||
                                  content?.file?.name.split('.').pop() === 'ppt') && (
                                  <img
                                    height={35}
                                    width={37}
                                    alt={formatMessage({ id: 'pptx' })}
                                    className='pe-2'
                                    src={toAbsoluteUrl(`/media/icons/file_extensions/${content?.file?.name.split('.').pop()}.svg`)}
                                  />
                                )}
                              {content &&
                                (content?.file?.name.split('.').pop() === 'jpg' ||
                                  content?.file?.name.split('.').pop() === 'png' ||
                                  content?.file?.name.split('.').pop() === 'jpeg') && (
                                  <img
                                    height={28}
                                    width={28}
                                    alt={formatMessage({ id: 'blank' })}
                                    className='pe-2'
                                    src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                                  />
                                )}
                              {content && content?.file?.name.split('.').pop() === 'xlsx' && (
                                <img
                                  height={28}
                                  width={28}
                                  alt={formatMessage({ id: 'blank' })}
                                  className='pe-2'
                                  src={toAbsoluteUrl(`/media/icons/file_extensions/${content?.file?.name.split('.').pop()}.svg`)}
                                />
                              )}
                              {content &&
                                !(
                                  content?.file?.name.split('.').pop() === 'pdf' ||
                                  content?.file?.name.split('.').pop() === 'docx' ||
                                  content?.file?.name.split('.').pop() === 'doc' ||
                                  content?.file?.name.split('.').pop() === 'pptx' ||
                                  content?.file?.name.split('.').pop() === 'ppt' ||
                                  content?.file?.name.split('.').pop() === 'jpg' ||
                                  content?.file?.name.split('.').pop() === 'png' ||
                                  content?.file?.name.split('.').pop() === 'jpeg' ||
                                  content?.file?.name.split('.').pop() === 'xlsx'
                                ) && (
                                  <img
                                    height={28}
                                    width={28}
                                    alt={formatMessage({ id: 'blank' })}
                                    className='pe-2'
                                    src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                                  />
                                )}
                            </>
                          )}
                          <p className='mb-0 ms-2'>{content?.file?.fileName}</p>
                        </div>
                        <div className='file-nav-list-right'>
                          <div className='file-nav-list-options'>
                            <button
                              type='button'
                              className='btn btn-sm card-option btn-icon btn-color-primary btn-active-light-primary file-nav '
                              onClick={() => {
                                setMenuOpen(
                                  menuOpen !== content.contentId ? content.contentId : null
                                )
                                setOneDropdownOpenBool(false)
                              }}
                            >
                              <img
                                src={moreOptionIcon}
                                alt={formatMessage({ id: 'more-option-icon' })}
                              />
                            </button>
                            {renameModalContentId ? (
                              <OutsideClickHandler onOutsideClick={() => setMenuOpen(null)}>
                                <SpaceFileDropdown
                                  isOpen={menuOpen === content?.contentId && !oneDropdownOpenBool}
                                  contentId={content?.contentId}
                                  parentId={content?.parentId}
                                  type={content.type}
                                  name={content.name}
                                  getDataRoomContentById={getDataRoomContentById}
                                  getDataRoomContentByparentId={getDataRoomContentByparentId}
                                  setMenuOpen={setMenuOpen}
                                  is_hidden={is_hidden}
                                  is_trash={is_Trash}
                                  dataroom_contentId={content?.dataroom_content?.dataroom_contentId}
                                />
                              </OutsideClickHandler>
                            ) : (
                              <OutsideClickHandler onOutsideClick={() => setMenuOpen(null)}>
                                <SpaceFileDropdown
                                  isOpen={menuOpen === content?.contentId && !oneDropdownOpenBool}
                                  contentId={content?.contentId}
                                  parentId={content?.parentId}
                                  type={content.type}
                                  name={content.name}
                                  getDataRoomContentById={getDataRoomContentById}
                                  getDataRoomContentByparentId={getDataRoomContentByparentId}
                                  setMenuOpen={setMenuOpen}
                                  is_hidden={is_hidden}
                                  is_trash={is_Trash}
                                  dataroom_contentId={content?.dataroom_content?.dataroom_contentId}
                                />
                              </OutsideClickHandler>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className='space-all-files-right flex-grow-1 ms-2'>
              {dataRoomContentParent &&
                breadcrumbLength !== 0 &&
                dataRoomContentParent?.map((el: any, index: number) => (
                  <EditSpaceFileRow
                    data={el}
                    handleClick={handleClick}
                    index={index}
                    getDataRoomContentById={getDataRoomContentById}
                    getDataRoomContentByparentId={getDataRoomContentByparentId}
                    dataRoomContentByParentLoading={dataRoomContentByParentLoading}
                  />
                ))}
              {!dataRoomContentByParentLoading && dataRoomContentParent?.length === 0 && (
                <NoDataPage width={`w-0`} mainfileActivity={true} />
              )}
            </div>
          </div>
        </>
      ) : !dataRoomContentLoading && dataRoomContent?.contents?.length === 0 ? (
        <NoDataPage width={`w-0`} mainfileActivity={true} />
      ) : (
        <div className='ms-4 my-4'>
          <Skeleton
            width={200}
            height={30}
            baseColor='var(--kt-skeleton-bg-color)'
            highlightColor='var(--kt-skeleton-highlight-bg-color)'
          />
          <div className='space-all-files-wrapper d-md-flex flex-column mt-3'>
            <Skeleton
              height={64}
              width={200}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
            <Skeleton
              height={64}
              width={200}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
            <Skeleton
              height={64}
              width={200}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        </div>
      )}
      {/* <UploadDrawer />
      <UploadOptionsDrawer getBreadcrumb={getDataRoomContentByparentId} DrClick={false}/> */}
      <ViewFileModal
        showViewFileModal={showViewFileModal}
        setShowViewFileModal={setShowViewFileModal}
        fileOriginalNameToView={fileOriginalNameToView}
        fileContentName={fileContentName}
      />
    </>
  )
}

export default SpaceAllFiles
